module.exports = __webpack_public_path__ + "static/media/payment-cardnew loanx3.6746fbdd.svg";